import { PortalApp } from "@wexinc/wex-common-web";
import React from "react";
import { useImmerReducer } from "use-immer";

export interface PortalAppStore {
  isInitialized: boolean;
  portalApps: PortalApp[];
}

const initialState: PortalAppStore = {
  isInitialized: false,
  portalApps: [],
};

interface PortalAppContext {
  portalAppStore: PortalAppStore;
  dispatch: (action: TAction) => PortalAppStore;
}

const Context = React.createContext<PortalAppContext>({
  portalAppStore: initialState,
  dispatch: () => initialState,
});

type TAction = { type: "set-portal-apps"; payload: PortalApp[] };

// This state is protected by immer so mutate-away!!
function reducer(state: PortalAppStore, action: TAction) {
  switch (action.type) {
    case "set-portal-apps":
      state.portalApps = action.payload;
      state.isInitialized = true;
      break;
  }
  return state;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function PortalAppProvider(props: any) {
  const [portalAppStore, dispatch] = useImmerReducer(reducer, initialState);
  const value = React.useMemo(
    () => ({ portalAppStore, dispatch }),
    // eslint-disable-next-line
    [portalAppStore],
  );
  return (
    <Context.Provider
      value={value}
      {...props}
    />
  );
}

export { PortalAppProvider, Context as PortalAppContext };
